import { action } from 'mobx';
import i18next from 'i18next';

import { AppManager } from 'core/index';

import { IssueConnManager } from 'apps/issueTracker/appManager';
import { IssuesQuery } from 'apps/issueTracker/gql';

export default class CommunityTasksManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.issuesConn = new IssueConnManager(this, {
      filterBy: [
        ['status', 'Open'],
        ['TrackerIssue.canAppearOnHome', 'true'],
      ],
      sortBy: 'recent',
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['comments', i18next.t('Comments')],
      ],
      initialBatchSize: 12,
      batchSize: 12,
      loadMoreQuery: IssuesQuery,
    });
    this.IssuesQuery();
  }

  @action IssuesQuery = () => {
    this.issuesConn.loadMore();
  };
}
